// extracted by mini-css-extract-plugin
module.exports = {"Input":"Input_Input__1L9we","Label":"Input_Label__3baqO","InputElement":"Input_InputElement__2Jm94","Invalid":"Input_Invalid__1x36u"};